// DA v2 — activée par défaut (GO prod 2026-10-11). Sortie de secours temporaire : ?da=1 (persistée), retour ?da=2. Aucune règle métier.
const KEY = "cf.da";

export function initDA() {
  const q = new URLSearchParams(window.location.search).get("da");
  if (q === "1") localStorage.setItem(KEY, "v1");
  if (q === "2") localStorage.removeItem(KEY);
  const on = localStorage.getItem(KEY) !== "v1";
  document.documentElement.classList.toggle("da-v2", on);
  return on;
}

export function isDAv2() {
  return document.documentElement.classList.contains("da-v2");
}
